export const demoData = {
  version: 1.0,
  title: "ServiceNow Demo",
  flows: [
    {
      id: 0,
      sections: [
        {
          id: 0,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "0",
              x: "0",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["ServiceNow_Step0_Title_card.jpg"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText: "",
        },
      ],
    },
    {
      id: 1,
      sections: [
        {
          id: 0,
          card: {
            transition: true,
            text: "Submit a hardware replacement request",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "0",
              x: "0",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: [""],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 1,
          card: {
            transition: false,
            text:
              "With the Now Virtual Agent, getting support for over 1,400 common IT tasks is as simple as chatting with a co-worker in Teams.",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "80%",
              x: "86%",
            },
            beacon: {
              isVisible: false,
              position: "top",
            },
          },
          images: {
            name: ["ServiceNow_Step1a_Image1a.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
          },
          screenReaderText: "Demo begins in a Teams channel titled “Design”.",
        },
        {
          id: 2,
          card: {
            transition: false,
            text: "Head to the Chat to get started",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "10.8%",
              x: "0.9%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["ServiceNow_Step1a_Image1b.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
          },
          screenReaderText:
            "In the same view, a user navigates to a vertical icon bar on the left side of the screen. The icon bar lists ten icons. Activity, Chat, Teams, Calendar, Calls, Files, Now Virtual Agent, and an ellipsis are at the top. The App and Help icons are at the bottom. A purple pop-up points to the Chat icon.",
        },
        {
          id: 3,
          card: {
            transition: false,
            text: "Open a chat and select the Now Virtual Agent",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "6.3%",
              x: "21.5%",
            },
            beacon: {
              isVisible: true,
              position: "top",
            },
          },
          images: {
            name: ["ServiceNow_Step1a_Image2.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
          },
          screenReaderText:
            "The view has changed to Chat. The main window shows an ongoing chat with Patti Fernandez. There is a vertical display to the left of this chat showing all the conversations the user has open. Above this vertical display, a purple pop-up points to an icon to being a new chat.",
        },
        {
          id: 4,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "6%",
              x: "27.5%",
            },
            beacon: {
              isVisible: true,
              position: "top",
            },
          },
          images: {
            name: ["ServiceNow_Step1a_Image3.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
          },
          screenReaderText:
            "he view has changed to show a new chat. A purple pop-up points to horizontal bar titled “To” at the top of the screen.",
        },
        {
          id: 5,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "11.8%",
              x: "28.4%",
            },
            beacon: {
              isVisible: true,
              position: "top",
            },
          },
          images: {
            name: ["ServiceNow_Step1a_Image4.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
          },
          screenReaderText:
            "In the same view, the user types “Now”, and a horizonal tile appears below the “To” bar that reads “Now Virtual Agent”. A purple pop-up points to the Now Virtual Agent icon in the horizontal tile.",
        },
        {
          id: 6,
          card: {
            transition: false,
            text:
              "Type “Hi” into the chat box to view a list of available options ",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "91.5%",
              x: "41%",
            },
            beacon: {
              isVisible: true,
              position: "bottom",
            },
          },
          images: {
            name: ["ServiceNow_Step1a_Image5.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
          },
          screenReaderText:
            "In the same view, “Now Virtual Agent” now appears in the “To” field at the top of the chat. There is a purple pop-up pointing to a chat box at the bottom of the screen, prompting the user to type into the chat box.",
        },
        {
          id: 6,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "96%",
              x: "81.8%",
            },
            beacon: {
              isVisible: true,
              position: "bottom",
            },
          },
          images: {
            name: ["ServiceNow_Step1a_Image6.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
          },
          screenReaderText:
            "In the same view, the user types “Hi”. A purple pop-up appears over a small send icon that’s shaped like a paper airplane.",
        },
        {
          id: 7,
          card: {
            transition: false,
            text: "Select “Submit a request” from the drop-down menu",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "78%",
              x: "64%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["ServiceNow_Step1a_Image8.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
          },
          screenReaderText:
            "In the same view, the “Hi” message has been sent, and appears in the chat thread.",
        },
        {
          id: 8,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "82%",
              x: "43%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["ServiceNow_Step1a_Image9.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
          },
          screenReaderText:
            "The Now Virtual Agent bot responds to the “Hi” message in the chat thread with a white card. The card reads “Welcome to Now Virtual Agent”. Under this message on the card, a message reads “Hi Megan, please enter your request of make a selection of what I can help you with. You can type Hi any time when you need help. Here are some available topics I can help you with.” A purple pop-up points to a drop-down menu below this message.",
        },
        {
          id: 9,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "82.5%",
              x: "44%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["ServiceNow_Step1a_Image11.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
          },
          screenReaderText:
            "In the same view, the user has expanded the drop down menu to reveal a vertically oriented list of choices: Identify Available Change Windows, Create Change Request, Live Agent Support, Provide Virtual Agent Feedback, Submit a request, Open IT Ticket. A purple pop-up appears over “Submit a request”.",
        },
        {
          id: 10,
          card: {
            transition: false,
            text: "Type your request into the chat box ",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "91.9%",
              x: "41%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["ServiceNow_Step1a_Image12.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
          },
          screenReaderText:
            "In the same view, the user clicks “Submit a request” from the drop down.",
        },
        {
          id: 11,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "95.9%",
              x: "81.8%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["ServiceNow_Step1a_Image12.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: true,
            sequenceSources: [
              "ServiceNow_Step1a_Image12.jpg",
              "ServiceNow_Step1a_Image13a.jpg",
              "ServiceNow_Step1a_Image13b.jpg",
              "ServiceNow_Step1a_Image13c.jpg",
              "ServiceNow_Step1a_Image13d.jpg",
              "ServiceNow_Step1a_Image13e.jpg",
              "ServiceNow_Step1a_Image13f.jpg",
            ],
          },
          screenReaderText:
            "In the same view, the drop down has disappeared, and “Submit a request” now appears on the card. There is a purple pop-up pointing to the “Submit” button on the card.",
        },
        {
          id: 12,
          card: {
            transition: false,
            text:
              "The Now Virtual Agent will automatically display all available options within the chat. These options are customizable within ServiceNow for your organization.",
            snack: {
              isVisible: true,
              position: "right",
            },
            position: {
              y: "78.9%",
              x: "85.8%",
            },
            beacon: {
              isVisible: false,
              position: "top",
            },
          },
          images: {
            name: ["ServiceNow_Step1a_Image15.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the chat thread, Now Virtual Agent sends a message that reads “What are you looking for?” A purple pop-up points to the chat box at the bottom of the screen, prompting the user to type.",
        },
        {
          id: 13,
          card: {
            transition: false,
            text: "Scroll through the options, and make a selection",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "69.9%",
              x: "65%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["ServiceNow_Step1a_Image15a.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view, the user has typed “I need a new laptop” into the chat box. A purple pop-up points to the send icon.",
        },
        {
          id: 14,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "69.9%",
              x: "65%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["ServiceNow_Step1a_Image16.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText: "The “I need a new laptop” message has been sent.",
        },
        {
          id: 15,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "69.9%",
              x: "65%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["ServiceNow_Step1a_Image17.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view, Now Virtual Agent has responded with a new card that reads “Here’s what I could find. Choose the appropriate option.” Below this text on the same card, there is an image of a Surface Pro 7, with an arrow to the right of the image, allowing the user to scroll through various options. Below the image, there is a button that says “Select”.",
        },
        {
          id: 16,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "78.9%",
              x: "43.5%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["ServiceNow_Step1a_Image18.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view, a purple pop-up points to the arrow on the card.",
        },
        {
          id: 17,
          card: {
            transition: false,
            text: "View the product specifications",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "68.9%",
              x: "64.5%",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["ServiceNow_Step1a_Image19.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view, the user has clicked the arrow, and the image has changed to a Sales Laptop. A purple pop-up points to an arrow to the right of the image.",
        },
        {
          id: 18,
          card: {
            transition: false,
            text:
              "Confirm the request by clicking the “Yes” button or typing “Yes” into the chat",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "83.5%",
              x: "42.4%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["ServiceNow_Step1a_Image20.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view, the user has clicked the arrow, and the image has changed to an Apple MacBook Pro 16’’. A purple pop-up points to an arrow to the right of the image.",
        },
        {
          id: 19,
          card: {
            transition: false,
            text:
              "Add an attachment to the chat to provide any additional documentation for the hardware request, or select the “No” button",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "84.8%",
              x: "46.4%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["ServiceNow_Step1a_Image21.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: true,
            sequenceSources: [
              "ServiceNow_Step1a_Image21.jpg",
              "ServiceNow_Step1a_Image22.jpg",
            ],
          },
          screenReaderText:
            "In the same view, the user has clicked the arrow, and the image has changed to a Development Laptop. A purple pop-up points to the “Select” button on the card.",
        },
        {
          id: 20,
          card: {
            transition: false,
            text: "Click “Yes” to finalize the request",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "83.8%",
              x: "42.4%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["ServiceNow_Step1a_Image23.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "The user has clicked “Submit”, and “Development Laptop” has been entered in the chat thread. Now Virtual Agent responds with a card that lists product specifications for the laptop. A purple box outlines these product specifications. Below that card, there’s a second card that reads “Should I proceed with this?” and two buttons that say “Yes” and No”.",
        },
        {
          id: 21,
          card: {
            transition: false,
            text:
              "View the request in the ServiceNow portal by clicking on the link provided in the chat",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "81.2%",
              x: "43.6%",
            },
            beacon: {
              isVisible: false,
              position: "right",
            },
          },
          images: {
            name: ["ServiceNow_Step1a_Image24.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view, the user has clicked the “No” button, and No appears in the chat thread. Now Virtual agent responds with a card that reads “Alright, I’m all set. Do you want me to submit this request? There are two buttons on the card: Yes and No. A purple pop-up points to the Yes button.",
        },
        {
          id: 22,
          card: {
            transition: false,
            text:
              "The Now Virtual Agent will send managers an actionable message in Teams to authorize requests and notify employees of approval.",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "81.2%",
              x: "43.6%",
            },
            beacon: {
              isVisible: false,
              position: "right",
            },
          },
          images: {
            name: ["ServiceNow_Step1a_Image25.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "The user has clicked the “Yes” button, and Yes now appears in the chat thread. Now Virtual Agent replies with a card that reads “Your request has been submitted. Here are the details. Below this, there is another section of the card with a deep link to the request in Service Now that will open the request in a browser. Below this, the last section of the tile reads “The conversation has ended. If you need help again, type Hi.  ",
        },
      ],
    },
    {
      id: 2,
      sections: [
        {
          id: 0,
          card: {
            transition: true,
            text: "Create and escalate an incident",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "0",
              x: "0",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: [""],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 1,
          card: {
            transition: false,
            text:
              "Employees can create and escalate IT tickets for common issues without leaving Teams.",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "83%",
              x: "86%",
            },
            beacon: {
              isVisible: false,
              position: "top",
            },
          },
          images: {
            name: ["ServiceNow_Step1b_Image1.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
          },
          screenReaderText:
            "The view is still in the chat thread with Now Virtual Agent. The user has typed “Hi” into the chat, prompting Now Virtual Agent to send a card. At the top, it says “Welcome to Now Virtual Agent”. Below that, the card reads “Hi Megan, please enter your request of make a selection of what I can help with. You can type Hi any time when you need help. Here are available topics I can help with.” Below this, there is a bar indicating a dropdown of options, as well as a button that reads “Submit.”",
        },
        {
          id: 2,
          card: {
            transition: false,
            text:
              "Type “Hi” into the Now Virtual Agent to view a list of available actions",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "56%",
              x: "80.6%",
            },
            beacon: {
              isVisible: false,
              position: "right",
            },
          },
          images: {
            name: ["ServiceNow_Step1b_Image2.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
          },
          screenReaderText:
            "In the same view, a purple box outlines the “Hi” in the chat thread.",
        },
        {
          id: 3,
          card: {
            transition: false,
            text: "Select “Open IT Ticket” from the dropdown",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "78%",
              x: "64%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["ServiceNow_Step1b_Image3.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
          },
          screenReaderText:
            "In the same view, a purple pop up points to the dropdown on the card from Now Virtual Agent.",
        },
        {
          id: 4,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "78.5%",
              x: "43%",
            },
            beacon: {
              isVisible: true,
              position: "top",
            },
          },
          images: {
            name: ["ServiceNow_Step1b_Image4.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
          },
          screenReaderText:
            "The user has clicked the drop down, expanding a vertically oriented list of options. A purple pop up points to “Open IT ticket”.",
        },
        {
          id: 5,
          card: {
            transition: false,
            text: "Type your issue into the chat box",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "91.7%",
              x: "41%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["ServiceNow_Step1b_Image5.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
          },
          screenReaderText:
            "In the same view, the user has selected “Open IT Ticket”, and Now Virtual Agent has responded with a message that reads “Please Enter a short description of your issue”. A purple pop-up points to the chat box at the bottom of the screen, prompting the user to type.",
        },
        {
          id: 6,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "95.7%",
              x: "81.8%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["ServiceNow_Step1b_Image6a.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: true,
            sequenceSources: [
              "ServiceNow_Step1b_Image5.jpg",
              "ServiceNow_Step1b_Image6a.jpg",
              "ServiceNow_Step1b_Image6b.jpg",
              "ServiceNow_Step1b_Image6c.jpg",
              "ServiceNow_Step1b_Image6d.jpg",
            ],
          },
          screenReaderText:
            "The user types “VPN not working” into the chat box. A purple pop-up points to the send icon.",
        },
        {
          id: 7,
          card: {
            transition: false,
            text: "Browse the knowledge articles related to your issue.",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "86.7%",
              x: "86.7%",
            },
            beacon: {
              isVisible: false,
              position: "right",
            },
          },
          images: {
            name: ["ServiceNow_Step1b_Image7.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view, the user has sent the message, and “VPN not working” has been added to the chat thread. Now Virtual Agent responds with card showing help articles about VPN issues. Below this, another message appears from Now Virtual Agent that reads “Did any of these articles resolve your issue?” with two buttons: Yes and No.",
        },
        {
          id: 8,
          card: {
            transition: false,
            text: "Click “No” to receive further support",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "83.7%",
              x: "46.3%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["ServiceNow_Step1b_Image7a.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view, a purple pop-up points to the “No” button.",
        },
        {
          id: 9,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "83.7%",
              x: "49.7%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["ServiceNow_Step1b_Image8.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "The user has clicked “No”, and it’s now in the chat thread. Now Virtual Agent responds with a card that reads “OK, what’s the urgency of your issue?” With three horizontally oriented buttons below the text: 1 – High, 1 – Medium, 3 – Low. A purple pop-up points to “2 – Medium”.",
        },
        {
          id: 10,
          card: {
            transition: false,
            text:
              "Once an employee indicates the urgency of an issue, the Now Virtual Agent will open an incident ticket, and automatically route it to the right technician.",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "78.7%",
              x: "49.7%",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["ServiceNow_Step1b_Image9.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "The user has clicked “2 – Medium”, and “2-Medium” has been added to the chat thread. Now Virtual Agent responds with a card that reads “Alright, I’ve opened your incident and a technician will be assigned.” Below this, a purple box outlines the details of the incident, with a button that reads “Go to Incident”. Just under this card, it reads “The conversation has ended. If you need help again, type Hi",
        },
        {
          id: 11,
          card: {
            transition: false,
            text:
              "View details of the incident in the chat, including category, a short description, progress state, priority level, and assignment group",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "72.7%",
              x: "64.7%",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["ServiceNow_Step1b_Image10.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view, a purple box outlines the incident details.",
        },
        {
          id: 12,
          card: {
            transition: false,
            text:
              "Select the “Go to Incident” button to view more details and add comments in the ServiceNow web app",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "79.2%",
              x: "46%",
            },
            beacon: {
              isVisible: false,
              position: "right",
            },
          },
          images: {
            name: ["ServiceNow_Step1b_Image11.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view, a purple box outlines the “Go to Incident” button.",
        },
        {
          id: 13,
          card: {
            transition: false,
            text:
              "Type “Escalate my incident” for faster resolutions with urgent incidents",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "92.2%",
              x: "41%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["ServiceNow_Step1b_Image12.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view, a purple pop-up points to the chat box at the bottom of the thread.",
        },
        {
          id: 14,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "95.9%",
              x: "81.8%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["ServiceNow_Step1b_Image12.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: true,
            sequenceSources: [
              "ServiceNow_Step1b_Image12.jpg",
              "ServiceNow_Step1b_Image13a.jpg",
              "ServiceNow_Step1b_Image13b.jpg",
              "ServiceNow_Step1b_Image13c.jpg",
              "ServiceNow_Step1b_Image13d.jpg",
              "ServiceNow_Step1b_Image13e.jpg",
              "ServiceNow_Step1b_Image13f.jpg",
              "ServiceNow_Step1b_Image13g.jpg",
            ],
          },
          screenReaderText:
            "The user types “Escalate my incident” into the chat box. A purple pop-up points to the send icon below the chat box.",
        },
        {
          id: 15,
          card: {
            transition: false,
            text:
              "Use the drop-down menu to choose the ticket you want to escalate",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "61.2%",
              x: "64.1%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["ServiceNow_Step1b_Image15.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText: "",
        },
        {
          id: 16,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "76.2%",
              x: "42.8%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["ServiceNow_Step1b_Image16.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "The user sends the message, and “Escalate my incident” is added to the chat thread. Now Virtual Agent responds with a card that reads “You have 5 open tickets, Which ticket do you want to escalate?” Below this text, there is a drop down that when clicked will expand to show open tickets, along with a “Submit” button. A purple pop-up points to the dropdown.",
        },
        {
          id: 17,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "66.2%",
              x: "43.8%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["ServiceNow_Step1b_Image17.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view, the user clicks the drop down, and a vertical list expands showing a list of 5 open tickets. A purple pop up points to a ticket titled “VPN not working [INC0010030]”",
        },
        {
          id: 18,
          card: {
            transition: false,
            text: "Confirm the escalation",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "83.5%",
              x: "42.3%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["ServiceNow_Step1b_Image18.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view, the user has selected the “VPN not working [INC0010030]”, and a purple pop-up points to the “Submit” button.",
        },
        {
          id: 19,
          card: {
            transition: false,
            text:
              "Include a justification for the escalation to add context and detail about the problem",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "91.7%",
              x: "41.3%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["ServiceNow_Step1b_Image19.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view, the ticket has been submitted and Now Virtual Agent has sent a card with the incident details. Below the incident details, another card reads “Would you like to escalate this ticket?” as well as two buttons: “Yes” and “No.” A purple pop-up points to the “Yes” button.",
        },
        {
          id: 20,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "95.7%",
              x: "81.9%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["ServiceNow_Step1b_Image19.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: true,
            sequenceSources: [
              "ServiceNow_Step1b_Image19.jpg",
              "ServiceNow_Step1b_Image20a.jpg",
              "ServiceNow_Step1b_Image20b.jpg",
              "ServiceNow_Step1b_Image20c.jpg",
              "ServiceNow_Step1b_Image20d.jpg",
            ],
          },
          screenReaderText:
            "In the same view, the user has clicked “Yes”. “Yes” appears in the chat thread, and Now Virtual Agent has sent a card that reads “Please enter a justification.” A purple pop-up points to the chat box at the bottom of the screen. The user types “Project deadline” into the chat box. A purple pop-up points to the send icon.",
        },
        {
          id: 21,
          card: {
            transition: false,
            text:
              "View the updated incident in the chat, indicating that the ticket priority has been escalated",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "81.5%",
              x: "49.9%",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["ServiceNow_Step1b_Image21.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "The user sends the “Project deadline” message, and it appears in the chat thread. Now Virtual agent sends a card indicating that the ticket has been escalated to 1 – High, and that the conversation has ended. A purple box outlives “I’ve escalated your ticket to 1 – High.”",
        },
        {
          id: 22,
          card: {
            transition: false,
            text:
              "Employees can monitor progress on the incident through notifications from the Now Virtual Agent in Teams.",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "83.5%",
              x: "49.9%",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["ServiceNow_Step1b_Image22.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText: "",
        },
      ],
    },
    {
      id: 3,
      sections: [
        {
          id: 0,
          card: {
            transition: true,
            text: "Reset your password",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "0",
              x: "0",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: [""],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 1,
          card: {
            transition: false,
            text:
              "The Now Virtual Agent helps employees instantly regain account access with an intuitive password reset tool.",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "82%",
              x: "0",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["ServiceNow_Step1c_Image1.jpg"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "The view is still in the chat thread with Now Virtual Agent. The user has typed “Hi” into the chat, prompting Now Virtual Agent to send a card. This card reads “Welcome to Now Virtual Agent”. Below that, the card reads “Hi Megan, please enter your request of make a selection of what I can help with. You can type Hi any time when you need help. Here are available topics I can help with.” Below this, there is a bar indicating a dropdown of options, as well as a button that reads “Submit.”",
        },
        {
          id: 2,
          card: {
            transition: false,
            text:
              "Type “Hi” into the Now Virtual Agent to view a list of available actions",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "56%",
              x: "80.5%",
            },
            beacon: {
              isVisible: false,
              position: "right",
            },
          },
          images: {
            name: ["ServiceNow_Step1c_Image2.jpg"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "In the same view, a purple box outlines the “Hi” in the chat thread.",
        },
        {
          id: 3,
          card: {
            transition: false,
            text:
              "Use the drop-down menu to browse the topics Now Virtual Agent can assist with, or type your request into the chat",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "78%",
              x: "64%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["ServiceNow_Step1c_Image3.jpg"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "In the same view, a purple pop up points to the dropdown on the card from Now Virtual Agent.",
        },
        {
          id: 4,
          card: {
            transition: false,
            text: "Choose “Get password reset link” from the menu",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "82.3%",
              x: "43%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["ServiceNow_Step1c_Image4.jpg"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "The user has clicked the drop down, expanding a vertically oriented list of options. A purple pop up points to “Get Password Reset Link”.",
        },
        {
          id: 5,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "82.8%",
              x: "43.9%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["ServiceNow_Step1c_Image5.jpg"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "The user has selected “Get Password Reset Link”, and a purple pop-up points to the “Submit” button on the Now Virtual Agent card.",
        },
        {
          id: 6,
          card: {
            transition: false,
            text:
              "In addition to providing a streamlined resolution process for IT issues, the Now Virtual Agent can be configured to assist with common HR tasks, such as payroll questions, adding emergency contacts, or updating email accounts.",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "73.8%",
              x: "43.9%",
            },
            beacon: {
              isVisible: false,
              position: "right",
            },
          },
          images: {
            name: ["ServiceNow_Step1c_Image6.jpg"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "In the same view, the user has clicked the “Submit” button, and Now Virtual Agent has sent a card that reads “Click here to reset your password. There is a deep link that reads “Password reset link.” Below this, another card from Now Virtual agent reads “The conversation has ended. If you need help again, type Hi.”",
        },
      ],
    },
    {
      id: 4,
      sections: [
        {
          id: 0,
          card: {
            transition: true,
            text: "Getting started",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "0",
              x: "0",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: [""],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 1,
          card: {
            transition: false,
            text:
              "Once an IT admin has connected the ServiceNow instance to Teams, users will be prompted to download Now Virtual Agent from the Teams store.",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "82%",
              x: "0",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["ServiceNow_Step3_Image1a.jpg"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 2,
          card: {
            transition: false,
            text: "Head to the Apps tab to get started",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "90%",
              x: "0.8%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["ServiceNow_Step3_Image1b.jpg"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "From a Teams channel a user navigates to a vertical icon bar on the left side of the screen. The icon bar lists ten icons: Activity, Chat, Teams, Calendar, Calls, Files, and an ellipsis are at the top. An app and help icon are at the bottom. A purple pop-up points to the App icon.",
        },
        {
          id: 3,
          card: {
            transition: false,
            text: "Search the Teams Store for the Now Virtual Agent app",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "12.5%",
              x: "10.2%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["ServiceNow_Step3_Image2.jpg"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "A new screen appears showing the Microsoft Teams app store. There is a purple pop up pointing to a search bar.",
        },
        {
          id: 4,
          card: {
            transition: false,
            text: "Click the Now Virtual Agent tile",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "12.7%",
              x: "25%",
            },
            beacon: {
              isVisible: true,
              position: "bottom",
            },
          },
          images: {
            name: ["ServiceNow_Step3_Image2.jpg"],
            imageAltText: "",
            sequence: true,
            sequenceSources: [
              "ServiceNow_Step3_Image2.jpg",
              "ServiceNow_Step3_Image3a.jpg",
              "ServiceNow_Step3_Image3b.jpg",
              "ServiceNow_Step3_Image3c.jpg",
            ],
          },
          screenReaderText:
            "In the same view, the user types “Service Now” into the search bar. A purple pop up points to the Now Virtual Agent card.",
        },
        {
          id: 5,
          card: {
            transition: false,
            text:
              "Install the app to streamline your incident creation flow within Teams",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "28.2%",
              x: "32%",
            },
            beacon: {
              isVisible: true,
              position: "top",
            },
          },
          images: {
            name: ["ServiceNow_Step3_Image4.jpg"],
            imageAltText: "",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "A large white box appears on the screen explaining the Now Virtual Agent app. There’s a purple pop-up pointing to a button that says “Install”.",
        },
        {
          id: 6,
          card: {
            transition: false,
            text:
              "Work with your Teams admin to pin the Now Virtual Agent app to the menu bar for your entire organization, displaying the tools most relevant to your users.",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "80%",
              x: "32%",
            },
            beacon: {
              isVisible: true,
              position: "top",
            },
          },
          images: {
            name: ["ServiceNow_Step3_Image5.jpg"],
            imageAltText: "",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "The Now Virtual Agent bot chat window is now open. There’s a white card explaining the bot’s functionality.",
        },
      ],
    },
    {
      id: 5,
      sections: [
        {
          id: 0,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "0",
              x: "0",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["ServiceNow_Step4_end_card.jpg"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText: "",
        },
      ],
    },
  ],
};
